<template>
    <div>
        <DCard padding>
            <DTable
                id="history-table"
                :fields="fields"
                :items="orderHistory"
            >
                <template #description="{item}">
                    <td>
                        {{ $page.props.auth.user.language_code === 'de' ? item.description_de : item.description_en }}
                    </td>
                </template>
                <template #comment="{item}">
                    <td>
                        {{ item.comment ? item.comment : '' }}
                    </td>
                </template>
                <template #date="{item}">
                    <td>
                        {{ item.date }}
                    </td>
                </template>
                <template #new_status="{item}">
                    <td>
                        <DTag :label="__('orders.status_'+item.new_status)" />
                    </td>
                </template>
            </DTable>
        </DCard>
    </div>
</template>

<script>
import OrderBase from '~@/Pages/Orders/Psa/Checks/Base'
import App from '~@/App.vue'

export default {
    name: 'History',
    layout: [App, OrderBase],
    props: {
        data: {
            type: Object,
            default: () => { return {} }
        },
        orderHistory: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'description', label: this.__('orders.check.description'), sorter: true },
                { key: 'user', label: this.__('orders.check.user'), sorter: true },
                { key: 'comment', label: this.__('orders.check.comment'), sorter: true },
                { key: 'date', label: this.__('orders.check.date'), sorter: true },
                { key: 'new_status', label: this.__('orders.check.new_status'), sorter: true }
            ]
        }
    }
}
</script>

<style scoped>

</style>
